/**
 * 路由权限检查工具
 * 用于判断路由是否需要登录验证
 */

import { matchRoutes } from '@umijs/max';
import routes from '../../config/routes';

/**
 * 检查当前路由是否需要登录
 * @param path 当前路径
 * @returns 是否需要登录
 */
export function isRouteNeedLogin(path: string): boolean {
  const matchedRoutes = matchRoutes(routes, path);

  if (matchedRoutes && matchedRoutes.length > 0) {
    // 获取匹配的最后一个路由（最具体的路由）
    const lastRoute = matchedRoutes[matchedRoutes.length - 1].route;
    // 如果路由配置了 login: false，则不需要登录
    return !((lastRoute as any).login === false);
  }

  // 默认需要登录
  return true;
}

/**
 * 检查是否为登录页面
 * @param pathname 路由路径
 * @returns 是否为登录页面
 */
export function isLoginPage(pathname: string | undefined): boolean {
  if (!pathname) return false;
  return pathname === '/user/login';
}

/**
 * 检查是否为邀请页面
 * @param pathname 路由路径
 * @returns 是否为邀请页面
 */
export function isInvitationPage(pathname: string | undefined): boolean {
  if (!pathname) return false;
  return pathname === '/user-invitation';
}
